function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3059",
  "data-name": "Group 3059",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3058",
  "data-name": "Group 3058"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_281",
  "data-name": "Path 281",
  d: "M3.178,25.153H21.027a2.783,2.783,0,0,0,2.785-2.785V13.4a.454.454,0,0,0-.909,0v8.97a1.874,1.874,0,0,1-1.876,1.877H3.178a3.16,3.16,0,0,0-2.248.931L.909,25.2V3.178A2.272,2.272,0,0,1,3.178.909H21.027a1.864,1.864,0,0,1,1.326.549A.454.454,0,1,0,23,.816,2.767,2.767,0,0,0,21.027,0H3.178A3.182,3.182,0,0,0,0,3.178V27.421A3.148,3.148,0,0,0,.316,28.8a3.2,3.2,0,0,0,2.863,1.8H21.027a2.788,2.788,0,0,0,2.785-2.785v-2.3a.454.454,0,0,0-.909,0v2.3a1.878,1.878,0,0,1-1.876,1.876H3.178a2.284,2.284,0,0,1-2.044-1.283,2.269,2.269,0,0,1,2.044-3.255Z",
  transform: "translate(0 0)",
  fill: "#ac1ede"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3061",
  "data-name": "Group 3061",
  transform: "translate(2.181 25.789)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3060",
  "data-name": "Group 3060"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_282",
  "data-name": "Path 282",
  d: "M56.2,431.505a.454.454,0,0,0-.454.454v1.34a.569.569,0,0,1-.568.569H36.95a.454.454,0,1,0,0,.909H55.177a1.479,1.479,0,0,0,1.477-1.477v-1.34A.454.454,0,0,0,56.2,431.505Z",
  transform: "translate(-36.496 -431.505)",
  fill: "#ac1ede"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3063",
  "data-name": "Group 3063",
  transform: "translate(2.181 26.253)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3062",
  "data-name": "Group 3062"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_283",
  "data-name": "Path 283",
  d: "M40.1,439.276H36.95a.454.454,0,0,0,0,.909H40.1a.454.454,0,0,0,0-.909Z",
  transform: "translate(-36.496 -439.276)",
  fill: "#ac1ede"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3065",
  "data-name": "Group 3065",
  transform: "translate(6.847 26.253)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3064",
  "data-name": "Group 3064"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_284",
  "data-name": "Path 284",
  d: "M128.014,439.276H115.023a.454.454,0,0,0,0,.909h12.991a.454.454,0,1,0,0-.909Z",
  transform: "translate(-114.569 -439.276)",
  fill: "#ac1ede"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3067",
  "data-name": "Group 3067",
  transform: "translate(6.12 10.663)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3066",
  "data-name": "Group 3066"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_285",
  "data-name": "Path 285",
  d: "M115.1,180.557a.454.454,0,0,0-.454.454v.437H103.312v-2.121h.8a.454.454,0,1,0,0-.909h-1.252a.454.454,0,0,0-.454.454v3.03a.454.454,0,0,0,.454.454H115.1a.454.454,0,0,0,.454-.454v-.891A.454.454,0,0,0,115.1,180.557Z",
  transform: "translate(-102.403 -178.419)",
  fill: "#ac1ede"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3069",
  "data-name": "Group 3069",
  transform: "translate(8.786 1.895)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3068",
  "data-name": "Group 3068"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_286",
  "data-name": "Path 286",
  d: "M168.372,31.7h-20.9a.454.454,0,0,0-.454.454V41.73a.454.454,0,0,0,.454.454h17.451a.454.454,0,1,0,0-.909h-17V32.611h20v8.665h-1.484a.454.454,0,0,0,0,.909h1.939a.454.454,0,0,0,.454-.454V32.156A.454.454,0,0,0,168.372,31.7Z",
  transform: "translate(-147.013 -31.702)",
  fill: "#ac1ede"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3071",
  "data-name": "Group 3071",
  transform: "translate(11.662 4.577)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3070",
  "data-name": "Group 3070"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_287",
  "data-name": "Path 287",
  d: "M197.922,76.584h-2.344a.457.457,0,0,0-.449.484.463.463,0,0,0,.449.484h.679v3.456a.466.466,0,0,0,.5.455.472.472,0,0,0,.5-.455V77.552h.673a.461.461,0,0,0,.449-.49A.454.454,0,0,0,197.922,76.584Z",
  transform: "translate(-195.129 -76.584)",
  fill: "#ac1ede"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3073",
  "data-name": "Group 3073",
  transform: "translate(16.233 4.577)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3072",
  "data-name": "Group 3072"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_288",
  "data-name": "Path 288",
  d: "M274.177,80.5h-1.568V79.487h.615a.445.445,0,0,0,.449-.461.454.454,0,0,0-.449-.478h-.615v-1h1.568a.461.461,0,0,0,.449-.49.451.451,0,0,0-.449-.472H272.1a.454.454,0,0,0-.478.449v3.975a.462.462,0,0,0,.478.455h2.081a.454.454,0,0,0,.449-.478A.463.463,0,0,0,274.177,80.5Z",
  transform: "translate(-271.617 -76.584)",
  fill: "#ac1ede"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3075",
  "data-name": "Group 3075",
  transform: "translate(20.302 4.565)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3074",
  "data-name": "Group 3074"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_289",
  "data-name": "Path 289",
  d: "M342.794,80.565l-.938-1.73.915-1.706a.544.544,0,0,0,.073-.269.5.5,0,0,0-.531-.473.555.555,0,0,0-.467.361l-.573,1.1-.576-1.1a.552.552,0,0,0-.465-.357.5.5,0,0,0-.531.472.544.544,0,0,0,.072.269l.91,1.707-.928,1.722,0,.009a.5.5,0,0,0-.055.229.5.5,0,0,0,.982.144l.6-1.127.6,1.127a.5.5,0,0,0,.982-.144A.5.5,0,0,0,342.794,80.565Z",
  transform: "translate(-339.695 -76.387)",
  fill: "#ac1ede"
})));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3077",
  "data-name": "Group 3077",
  transform: "translate(24.481 4.577)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3076",
  "data-name": "Group 3076"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_290",
  "data-name": "Path 290",
  d: "M412.423,76.584h-2.344a.457.457,0,0,0-.449.484.463.463,0,0,0,.449.484h.679v3.456a.466.466,0,0,0,.5.455.472.472,0,0,0,.5-.455V77.552h.673a.46.46,0,0,0,.449-.49A.454.454,0,0,0,412.423,76.584Z",
  transform: "translate(-409.63 -76.584)",
  fill: "#ac1ede"
})));

var SvgBookedit = function SvgBookedit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cover",
    width: 30.6,
    height: 30.6,
    viewBox: "0 0 30.6 30.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookedit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookedit.df31f9aa.svg";
export { ForwardRef as ReactComponent };